import ProductInfo from '@/components/app/store/components/introCard/productInfo';
import Container from '@/components/@base/container';
import Rate from '@/components/@base/rate';
import ProductModel from '@/models/product.model';


type Props = {
  product: ProductModel;
  storeLocalization: {average_user_rating:string };
};

export default function RateInfo({
                                   product,
                                   storeLocalization,
                                    }: Props) {
  if (product.rate.rateAverage<1){
    return null;
  }
  return (
    <Container>
      <ProductInfo
        title={product.rate.rateAverage.toFixed(2)}
        subTitle={storeLocalization.average_user_rating}
      />
      <Container className='mt-1 w-[82px]'>
        <Rate value={product.rate.rateAverage} readOnly spaceInside='small' />
      </Container>
    </Container>
  );

}
